/**
 * Clown.art — Smooth Scroll (desktop only)
 * --------------------------------------------------------------
 * Boots Lenis on desktop (fine pointer + width ≥ 1024 + no reduced-motion).
 * Mobile / touch / reduced-motion → native scroll, zero overhead.
 *
 * Integrations:
 *  - Cart drawer open/close → lenis.stop() / lenis.start()
 *  - In-page anchor clicks (href="#...") → lenis.scrollTo()
 *  - Exposes window.clownLenis for other modules.
 *
 * Depends on lenis.min.js loaded BEFORE this script (UMD global `Lenis`).
 */
(function () {
  'use strict';

  if (typeof window === 'undefined') return;

  function shouldEnable() {
    if (typeof window.Lenis !== 'function') return false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    if (window.matchMedia('(pointer: coarse)').matches) return false;
    if (window.innerWidth < 1024) return false;
    return true;
  }

  function init() {
    if (!shouldEnable()) return;

    var lenis = new window.Lenis({
      duration: 1.05,
      easing: function (t) { return t === 1 ? 1 : 1 - Math.pow(2, -10 * t); }, // easeOutExpo
      smoothWheel: true,
      smoothTouch: false,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      infinite: false
    });

    function raf(time) {
      lenis.raf(time);
      window.requestAnimationFrame(raf);
    }
    window.requestAnimationFrame(raf);

    window.clownLenis = lenis;

    /* ----- Cart drawer integration -----
       Dawn cart-drawer toggles `html.cart-drawer-active`. Observe it. */
    try {
      var htmlEl = document.documentElement;
      var mo = new MutationObserver(function () {
        if (htmlEl.classList.contains('cart-drawer-active')
            || htmlEl.classList.contains('menu-opening')) {
          lenis.stop();
        } else {
          lenis.start();
        }
      });
      mo.observe(htmlEl, { attributes: true, attributeFilter: ['class'] });
    } catch (e) { /* noop */ }

    /* ----- In-page anchor smooth scroll ----- */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href === '#' || href.length < 2) return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -16, duration: 1.2 });
      // Update URL without jumping
      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', href);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
